import { formatDate, WidgetWrapper } from '@agentselly/ui';
import { PriceDevelopmentHistoryChart } from '~/components/charts/PriceDevelopmentHistoryChart.tsx';
import { formatPrice } from '~/helper/formatPrice.ts';

interface Props {
  readonly evaluationTimestamp: number;
  readonly evaluationValue: number;
  readonly evaluationValueFromLarge: number | undefined;
  readonly evaluationValueFromSmall: number | undefined;
  readonly evaluationValueToLarge: number | undefined;
  readonly evaluationValueToSmall: number | undefined;
  readonly evaluationHistory: {
    readonly value: number;
    readonly timestamp: number;
  }[];
}

export function PartnerEvaluationValueWidget(props: Props) {
  return (
    <WidgetWrapper title="Marktwert">
      <div className="border-2 border-primary-400 rounded-lg p-4 md:p-8 flex flex-col gap-2 justify-between items-center w-full">
        <p className="text-xs">
          Bewertung vom{' '}
          {formatDate(props.evaluationTimestamp, { fallback: '...' })}
        </p>
        <p className="text-xl font-bold">
          {formatPrice(props.evaluationValue, '...')}
        </p>
        <p>
          (von {formatPrice(props.evaluationValueFromSmall, '...')} bis{' '}
          {formatPrice(props.evaluationValueToSmall, '...')})
        </p>
      </div>
      <br />
      <div className="border border-gray-100 dark:border-gray-700 rounded-lg">
        <PriceDevelopmentHistoryChart
          datasetIdKey="evaluation"
          priceHubbleHistory={
            props.evaluationHistory
              ?.map((it) => ({
                value: it.value,
                upperValue: it.value,
                lowerValue: it.value,
                date: it.timestamp,
              }))
              ?.sort((a, b) => a.date - b.date) || []
          }
        />
      </div>
    </WidgetWrapper>
  );
}
